import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-gelios-select-field',
  templateUrl: './gelios-select-field.component.html',
})
export class GeliosSelectFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  private _items: Array<any>;

  get items(): Array<any> {
    return this._items;
  }
  @Input() set items(value: Array<any>) {
    this._items = value;
    this.autoSelectIfOnlyOneOption();
  }
  @Input() selectedItem: string;
  public label: string;
  public bindValue: string;
  public multiple: boolean;

  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.reflexiveField && this.reflexiveField.value) {
      this.selectedItem = this.reflexiveField.value;
    }
    this.autoSelectIfOnlyOneOption();
  }

  autoSelectIfOnlyOneOption() {
    const selectSettings = this.reflexiveField.selectSettings;
    if (
      selectSettings.autoSelectIfOnlyOneOption
      && this.formGroup
      && this.formGroup.controls[this.fieldName]
      && !this.selectedItem
      && this.items.length === 1
    ) {
      this.formGroup.controls[this.fieldName].setValue(
        selectSettings.multiple ?
          [this.items[0][selectSettings.bindValue]] : this.items[0][selectSettings.bindValue]
      );
    }

  }

  onExternalValueChange(value) {
    this.onValueChange(value);
  }
}
